import { render, staticRenderFns } from "./ALiYunCaptcha.vue?vue&type=template&id=08cb57fe&scoped=true"
import script from "./ALiYunCaptcha.vue?vue&type=script&lang=js"
export * from "./ALiYunCaptcha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cb57fe",
  null
  
)

export default component.exports